var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 264.15,
    height: 162,
    viewBox: "0 0 264.15 162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2677",
    "data-name": "Rectangle 2677",
    width: 56.242,
    height: 81.778,
    transform: "translate(0 0)",
    fill: "#e6694a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2677-2",
    "data-name": "Rectangle 2677",
    width: 81.712,
    height: 118.813,
    transform: "translate(0 0)",
    fill: "#e6694a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2677-3",
    "data-name": "Rectangle 2677",
    width: 111.413,
    height: 162,
    transform: "translate(0 0)",
    fill: "#e6694a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2142",
    "data-name": "Group 2142",
    transform: "translate(-1466 -449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2094",
    "data-name": "Group 2094",
    transform: "translate(1522.242 611) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2093",
    "data-name": "Group 2093",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6493",
    "data-name": "Path 6493",
    d: "M29.192,34.407V81.778l27.05-56.445L46.657,0H9.585L0,25.334,27.05,81.778V34.407a7.785,7.785,0,1,1,2.142,0",
    transform: "translate(0 0)",
    fill: "#e6694a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2095",
    "data-name": "Group 2095",
    transform: "translate(1612.625 611) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2093-2",
    "data-name": "Group 2093",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6493-2",
    "data-name": "Path 6493",
    d: "M42.412,49.989v68.824l39.3-82.006L67.786,0H13.926L0,36.807l39.3,82.006V49.989a11.31,11.31,0,1,1,3.113,0",
    transform: "translate(0 0)",
    fill: "#e6694a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2096",
    "data-name": "Group 2096",
    transform: "translate(1730.15 611) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2093-3",
    "data-name": "Group 2093",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6493-3",
    "data-name": "Path 6493",
    d: "M57.829,68.159V162L111.413,50.185,92.426,0H18.987L0,50.185,53.585,162V68.159a15.421,15.421,0,1,1,4.244,0",
    transform: "translate(0 0)",
    fill: "#e6694a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.cf1325de1a1f042ae8d6a58af56bc829.svg";
export { ForwardRef as ReactComponent };